/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Billing_Ends_OnInputs */

const en_settings_billing_ends_on = /** @type {(inputs: Settings_Billing_Ends_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends on ${i?.date}`)
};

const zh_settings_billing_ends_on = /** @type {(inputs: Settings_Billing_Ends_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 到期`)
};

/**
* | output |
* | --- |
* | "Ends on {date}" |
*
* @param {Settings_Billing_Ends_OnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_ends_on = /** @type {((inputs: Settings_Billing_Ends_OnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Ends_OnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_ends_on(inputs)
	return zh_settings_billing_ends_on(inputs)
});
export { settings_billing_ends_on as "settings.billing.ends_on" }